/**
 * Extract a field from analysis_result, checking multiple possible key names.
 * Handles both old and new analysis prompt formats.
 */
function getField(analysis, ...keys) {
  if (!analysis) return undefined;
  for (const k of keys) {
    const val = analysis[k];
    if (val !== undefined && val !== null && val !== '') return val;
  }
  return undefined;
}

/**
 * Get the intent string from an analysis result (handles old field names + object values).
 */
export function getIntent(analysis) {
  const raw = getField(analysis, 'intent', 'buyer_intent', 'customer_intent', 'caller_intent');
  if (!raw) return null;
  if (typeof raw === 'object') return raw.action || raw.label || JSON.stringify(raw);
  return String(raw);
}

/**
 * Get the next action string from an analysis result (handles old field names + object values).
 */
export function getNextAction(analysis) {
  const raw = getField(analysis, 'next_action', 'next_steps', 'recommended_action', 'follow_up');
  if (!raw) return null;
  if (typeof raw === 'object') return raw.action || raw.label || JSON.stringify(raw);
  return String(raw);
}

/**
 * Get the summary string from an analysis result.
 */
export function getSummary(analysis) {
  const raw = getField(analysis, 'summary', 'call_summary');
  if (!raw) return null;
  if (typeof raw === 'object') return JSON.stringify(raw);
  return String(raw);
}
